export default __webpack_public_path__ + "static/media/1.88d507aa.png";